import React, { useContext, useEffect, useRef, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ThemeContext } from '../Layout/Theme/ThemeContext';
import ModuleService from '../../Modules/Setup/controller/ModuleController/ModuleController';
import { SidebarContext } from './SidebarContext';
import { useTranslation } from 'react-i18next';
import $ from 'jquery';

function Header() {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { sidebarModules = [], updateSidebarModules } = useContext(SidebarContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const toggleSidebarDivRef = useRef(null);
  const sidebarRef = useRef(null);
  const mainContentRef = useRef(null);

  // Wrap updateSidebarModules with useCallback to prevent unnecessary re-renders
  const stableUpdateSidebarModules = useCallback(updateSidebarModules, []);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const modules = await ModuleService.GetAllModules(() => {
          navigate('/');
        }, "en");
        stableUpdateSidebarModules(modules);
      } catch (error) {
        console.error('Failed to fetch modules:', error);
      }
    };

    fetchModules();
  }, [stableUpdateSidebarModules, navigate]); // Dependencies include only stable references
  useEffect(() => {
    const sidebar = sidebarRef.current;
    const mainContent = mainContentRef.current;

    // Function to check and hide sidebar on mobile
    const handleResponsiveSidebar = () => {
      if (window.innerWidth <= 768) {  // Adjust threshold as needed
        if (sidebar) {
          sidebar.classList.add('sidemenu-toggle');
          sidebar.classList.add('hide-nav-title');
        }
        if (mainContent) {
          mainContent.classList.add('hide-sidemenu');
        }
      }
    };

    handleResponsiveSidebar(); // Run on mount

    window.addEventListener('resize', handleResponsiveSidebar); // Adjust on resize

    return () => {
      window.removeEventListener('resize', handleResponsiveSidebar);
    };
  }, []);

  useEffect(() => {
    const toggleSidebarDiv = toggleSidebarDivRef.current;
    const sidebar = sidebarRef.current;
    const mainContent = mainContentRef.current;

    const handleToggleSidebar = () => {

      if (sidebar) {

        sidebar.classList.toggle('sidemenu-toggle');
        sidebar.classList.toggle('hide-nav-title');
      }
      if ($(".main-content").hasClass("hide-sidemenu")) {
        $(".main-content").removeClass("hide-sidemenu");
      }
      else {
        $(".main-content").addClass("hide-sidemenu");
      }
      if (mainContent) {

        mainContent.classList.toggle('hide-sidemenu');
      }
    };

    if (toggleSidebarDiv) {
      toggleSidebarDiv.addEventListener('click', handleToggleSidebar);
    }

    return () => {
      if (toggleSidebarDiv) {
        toggleSidebarDiv.removeEventListener('click', handleToggleSidebar);
      }
    };
  }, []);
  useEffect(() => {
    document.body.classList.toggle('dark-theme', theme === 'dark');
  }, [theme]);

  function renderNavItem(module, theme, activePath) {
    const isMobile = window.innerWidth <= 768;
    const moduleURL = isMobile && module.FormMobile ? module.FormMobile : module.FormURL;
    const isActive = activePath === moduleURL;
    const iconUrl = theme === 'light' ? module.LightIcon : module.DarkIcon;
    const closeSidebarOnMobile = () => {
      if (isMobile) {
        const sidebar = document.querySelector(".sidemenu-area");
        const mainContent = document.querySelector(".main-content");
        if (sidebar) {
          sidebar.classList.add("sidemenu-toggle");
          sidebar.classList.add("hide-nav-title");
        }
        if (mainContent) {
          mainContent.classList.add("hide-sidemenu");
        }
      }
    };
    return (
      (!isMobile || (isMobile && module.IsMobile === 1)) && (
        <Link
          key={moduleURL}
          className={`nav-link ${isActive ? 'active' : ''}`}
          to={moduleURL}
          onClick={closeSidebarOnMobile}
        >
          <img
            src={iconUrl}
            alt="Icon"
            className={`icon ${theme === 'dark' ? 'text-white' : ''}`}
          />
          <span className="title">{module.vc_ModuleName}</span>
        </Link>
      )
    );

  }

  return (
    <div>
      <div className="side-logo-section">
        <a className="navbar-brand" href="#" style={{ "marginRight": "0rem" }}>
          <img className="large-logo" src="assets/img/logo.png" />
        </a>

        <div ref={toggleSidebarDivRef} className="burger-menu">
          <span className="top-bar"></span>
          <span className="middle-bar"></span>
          <span className="bottom-bar"></span>
        </div>
      </div>
      <div ref={sidebarRef} className="sidemenu-area default">
        <nav className="sidemenu navbar navbar-expand navbar-light">
          <div className="navbar-collapse collapse">
            <div className="navbar-nav">
              <Link className="nav-link" to="/Dashboard">
                <img
                  src="./assets/img/icons/btnDashboardL.png"
                  alt="Dashboard Icon"
                  className={`icon ${theme === 'dark' ? 'text-white' : ''}`}
                />
                <span className="title">Dashboard</span>
              </Link>

              {sidebarModules.map(module => renderNavItem(module, theme, location.pathname))}
            </div>

          </div>

        </nav>
        <div className="sidebar-version" style={{position:"fixed",bottom:"10px",left:"0",width:"120px",textAlign:"center",fontSize:"14px",color:"#000",zIndex:"9999",pointerEvents:"none"}}>
          <small>Version No: d228c8f</small>
        </div>
      </div>

    </div>
  );
}

export default Header;
